// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout--blank[data-v-124dbb66]{display:flex;flex-direction:column;justify-content:space-between;height:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
